import * as React from 'react';

import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';

import { JourneyDetails, DurationStops, HygieneMessaging } from '.';
import { Airline } from 'components/shared';
import JourneyType from 'types/search/listings/journey';

export interface JourneyProps {
  journey: JourneyType;
}

export const Journey = ({ journey }: JourneyProps) => (
  <UitkLayoutGrid columns={{ medium: 12 }}>
    <UitkLayoutGridItem colSpan={{ medium: 7, large: 6 }}>
      <div>
        <JourneyDetails
          departureAndArrivalTime={journey.departureAndArrivalTime}
          differentDayArrival={journey.differentDayArrival}
          differentDayArrivalAccessibilityMessage={journey.differentDayArrivalAccessibilityMessage}
          departureAndArrivalAirport={journey.departureAndArrivalLocations}
        />
      </div>
    </UitkLayoutGridItem>
    <UitkLayoutGridItem colSpan={{ medium: 5, large: 6 }}>
      <div>
        <DurationStops durationAndStops={journey.durationAndStops} layoverInformation={journey.layoverInformation} />
      </div>
    </UitkLayoutGridItem>
    <UitkLayoutGridItem colSpan="all" className="all-b-padding-one uitk-type-200 all-t-margin-two">
      <div>
        <Airline
          logo={journey.airlines[0].image}
          name={journey.airlines[0].text}
          flightOperatedBy={journey.flightOperatedBy}
          queued={true}
        />
      </div>
    </UitkLayoutGridItem>
    <UitkLayoutGridItem colSpan="all" className="all-t-margin-one">
      <div>
        <HygieneMessaging message={journey.hygieneAmenitiesMessage} />
      </div>
    </UitkLayoutGridItem>
  </UitkLayoutGrid>
);

export default Journey;
